import { Link } from '@tanstack/react-router'
import { useTranslation } from '@kostbar/i18n'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface ItemImagePreviewDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  imageUrl: string
  name: string
  sku: string
}

export function ItemImagePreviewDialog({
  open,
  onOpenChange,
  imageUrl,
  name,
  sku,
}: ItemImagePreviewDialogProps) {
  const { t: tMenus } = useTranslation('menus')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>{name}</DialogTitle>
        </DialogHeader>
        <img
          src={imageUrl}
          alt={name}
          className="w-full max-h-[60vh] rounded object-contain bg-muted"
        />
        <div className="flex justify-end">
          <Button variant="outline" asChild>
            <Link to="/products/$sku" params={{ sku }}>
              {tMenus('imagePreview.toProduct')}
            </Link>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
